export const fiscal = {
	fieldsIvaFactura: {
		apikey: {
			label: "Clave de API",
			placeholder: "Ingresar clave de API",
		},
		secretkey: {
			label: "Clave Secreta de API",
			placeholder: "Ingresar clave secreta de API",
		},
		fiscalProductGroup: {
			label: "Grupo fiscal de producto",
			placeholder: "Elegir grupo fiscal de producto",
		},
		autoInvoicingURL: {
			label: "URL de autofacturación",
			placeholder: "Ingresar URL de autofacturación",
		},
		issuerDocument: {
			label: "RFC del emisor",
			placeholder: "Ingresar RFC del emisor",
		},
		expiration: {
			label: "Fecha de expiración",
			placeholder: "Elija una opción para fecha de expiración",
			expirationDaysLabel: "Días después de la fecha de transacción",
			expirationDaysPlaceholder: "Elegir días después de la fecha de transacción",
			expirationDaysHint:
				"Al definir un plazo que exceda el mes de creación de la transacción, la fecha de expiración será el último día del mes.",
			lastMonthDay: "En el último día del mes",
			daysAfterTransaction: "Días después de la fecha de transacción",
		},
	},
	fieldsIvaVendus: {
		apikey: {
			label: "Clave de API",
			placeholder: "Ingresar clave de API",
		},
		cashierIds: {
			label: "ID de las cajas",
			placeholder: "Ingresar ID de las cajas",
		},
		country: {
			label: "País",
			placeholder: "Seleccionar país",
			options: {
				PT: "PT - Portugal",
				ES: "ES - España",
			},
		},
		paymentMethodIds: {
			labelCash: "Efectivo",
			labelCredit: "Crédito",
			labelDebit: "Débito",
			labelMbway: "Mbway",
			labelOthers: "Otros",
			labelPayment: "IDs de las formas de pago:",
			placeholderPaymentId: "Ingresar ID",
		},
	},
	fieldsNfce: {
		certificate: {
			label: "Certificado",
		},
		certificatePassword: {
			label: "Contraseña del certificado",
			placeholder: "Ingresar contraseña del certificado",
		},
		cscNfceHomologation: {
			label: "CSC NFC-e homologación",
			placeholder: "Ingresar CSC NFC-e homologación",
		},
		cscNfceProduction: {
			label: "CSC NFC-e producción",
			placeholder: "Ingresar CSC NFC-e producción",
		},
		expirationDate: {
			label: "Fecha de expiración",
			placeholder: "00/00/0000",
		},
		idNfceHomologation: {
			label: "ID NFC-e homologación",
			placeholder: "Ingresar ID NFC-e homologación",
		},
		idNfceProduction: {
			label: "ID NFC-e producción",
			placeholder: "Ingresar ID NFC-e producción",
		},
	},
	fieldsSat: {
		serialNumberSat: {
			label: "Número de serie SAT",
			placeholder: "Ingresar número de serie SAT",
		},
	},
	optionsTaxation: {
		SimpleNationalExcess: "Régimen simplificado exceso",
		normalRegime: "Régimen normal",
		simpleNational: "Régimen simplificado",
	},
};
